import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { SurveyPaginateList } from '../../../../types/survey-types';
import PruTable from '../../../../../../common/components/PruTable/PruTable';
import { SURVEY_BASE_PATH, SURVEY_MANAGEMENT_PATH } from '../../../../constants';
import { useHistory } from 'react-router-dom';
import { getDefaultDisplayDate } from 'src/app/common/utils';

type SurveyListProps = {
  isLoading: boolean;
  surveyList?: SurveyPaginateList;
  onRefresh: () => void;
  onChangePage: (page: number, rowsPerPage: number) => void;
};

const SurveyList: FC<SurveyListProps> = ({ isLoading, onRefresh, onChangePage, surveyList }) => {
  const history = useHistory();
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });

  return (
    <PruTable
      disableBulkSelect
      dataSource={surveyList?.items}
      isLoading={isLoading}
      onRefresh={onRefresh}
      title={Translation('survey.list')}
      headerBtnDef={[
        {
          color: 'primary',
          title: Translation('survey.newSurvey'),
          onClick: () => history.push(`${SURVEY_BASE_PATH}${SURVEY_MANAGEMENT_PATH}/create`),
        },
      ]}
      operationDef={[
        {
          title: Translation('section.common.operation.edit'),
          tooltipText: 'Edit Survey',
          onClick: (row) => history.push(`${SURVEY_BASE_PATH}${SURVEY_MANAGEMENT_PATH}/edit/${row.id}`),
        },
        {
          title: Translation('section.common.operation.viewResults'),
          tooltipText: 'View Survey Results',
          onClick: (row) => history.push(`${SURVEY_BASE_PATH}${SURVEY_MANAGEMENT_PATH}/${row.id}/results`),
        },
      ]}
      columnDef={[
        {
          isId: true,
          hidden: true,
          keyIndex: 'id',
          displayName: '',
          renderData: () => '',
        },
        {
          keyIndex: 'title',
          displayName: Translation('survey.common.title'),
          renderData: (row) => row.title,
        },
        {
          keyIndex: 'noOfQuestions',
          align: 'center',
          displayName: Translation('survey.common.noOfQuestions'),
          renderData: (row) => String(row.noOfQuestions),
        },
        {
          keyIndex: 'startDate',
          align: 'center',
          displayName: Translation('survey.common.startDate'),
          renderData: (row) => getDefaultDisplayDate(row.startDate, 'datetime'),
        },
        {
          keyIndex: 'endDate',
          align: 'center',
          displayName: Translation('survey.common.endDate'),
          renderData: (row) => getDefaultDisplayDate(row.endDate, 'datetime'),
        },
        {
          keyIndex: 'createdAt',
          align: 'center',
          displayName: Translation('survey.common.createdAt'),
          renderData: (row) => getDefaultDisplayDate(row.createdAt, 'datetime'),
        },
        {
          keyIndex: 'updatedAt',
          align: 'center',
          displayName: Translation('survey.common.updatedAt'),
          renderData: (row) => getDefaultDisplayDate(row.updatedAt, 'datetime'),
        },
      ]}
      totalPages={surveyList?.totalPages}
      totalRecords={surveyList?.totalRecords}
      onChangePage={onChangePage}
    />
  );
};

export default SurveyList;
